import React, { useState } from 'react'

import { ExitPrompt, ExitPromptType } from '@frame/ui-components/exit-prompt'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { Button } from '@frame/ui-primitives/button'
import { Card } from '@frame/ui-primitives/card'
import { H2 } from '@frame/ui-primitives/h2'
import { H5 } from '@frame/ui-primitives/h5'

import { DirectTask, TrueworkJsStrategy } from '@frame/lib/api/tasks/types'
import { useShowExitPrompt } from '@frame/lib/hooks/useShowExitPrompt'

import { useVerifyTask } from '../../hooks/useVerifyTask'
import { BankInfoCard } from './bank-info-card'

type Props = {
  tasks: DirectTask[]
}

export function BankAndPosTasks({ tasks }: Props) {
  const showExitPrompt = useShowExitPrompt()

  const [showIncompletePrompt, setShowIncompletePrompt] = useState(false)

  const { handleConnectBank } = useVerifyTask()

  const bankTask = tasks.find((task) => task.strategy === TrueworkJsStrategy.BANK)
  if (!bankTask) {
    throw new Error('Bank task not found')
  }

  return (
    <>
      <WidgetHeaderWithNavigation showCobranding backButton={{ visible: false }} showExitPrompt={showExitPrompt} />
      <Body className="h-full p-5" paddingTopOverride={8}>
        <div className="flex h-full flex-col justify-between">
          <div className="flex-1">
            <H2 className="mb-4 text-left text-moss-700">Do you know your bank account login?</H2>
            <BankInfoCard />
          </div>
          <div>
            <Card intent="primary" className="p-4">
              <H5 as="div">Fastest way to complete income screening</H5>
              <Button applyCobranding className="mt-4" onClick={() => handleConnectBank(bankTask)}>
                Yes, connect bank accounts now
              </Button>
            </Card>
            <Button intent="secondary" className="mt-4">
              No, I don't know bank login
            </Button>
          </div>
        </div>
      </Body>
      <ExitPrompt
        show={showIncompletePrompt}
        hide={() => setShowIncompletePrompt(false)}
        title="Submit incomplete tasks?"
        type={ExitPromptType.INCOMPLETE}
      />
    </>
  )
}
